import {
  gliderInjectionKey,
  numberOfSlidesInjectionKey,
} from './injection-keys';

export const freeCarouselConfig = {
  gliderInjectionKey,
  numberOfSlidesInjectionKey,
};
